import React, { Component } from "react";
import "./Lessons.css";
import { NavLink} from "react-router-dom";
import { lessonsList } from "../../data/lessonsList.js";
import Result from "./Result";


class Lessons extends Component{
  constructor(props){
    super(props);
    this.lessonHeaderRef = React.createRef();
    this.resultHeaderRef = React.createRef();
  }

  //Focus is only set when the page first loads. Switching layouts moves the results in
  //the DOM (remounting them), and that should not pull focus away from the user.
  componentDidMount(){
    if(this.props.stackedLayout){
      this.focusTimeout = setTimeout(()=>{
        if(this.lessonHeaderRef.current !== null)
          this.lessonHeaderRef.current.focus();
      },250);
    }
    else if(this.resultHeaderRef.current !== null){
      this.resultHeaderRef.current.focus();//Have screen reader users start on the results header
    }
  }

  componentWillUnmount(){
    clearTimeout(this.focusTimeout);
  }

  render(){
    //When the side by side layout no longer fits, the results go below the lessons. They are
    //moved in the DOM rather than with CSS order so the reading order matches what is shown.
    const result = (
      <div className="container-result">
        <Result headerRef={this.resultHeaderRef} />
      </div>
    );

    return (
      <div className={this.props.stackedLayout ? "container container-stacked" : "container"}>
        {!this.props.stackedLayout && result}
        <div className="container-lessons" tabIndex={0}>
          <div>
            <h1 tabIndex={0} ref={this.lessonHeaderRef}>Lessons</h1>
          </div>
          {lessonsList.map((lessonItem) => ( 
            <div className="card" aria-label={lessonItem.title} key={lessonItem.id}>
              <NavLink 
                  to={`/lessons/${lessonItem.id}`}
                  key={lessonItem.id}>
                  <span>{lessonItem.title}</span>
              </NavLink>
            </div>
          ))}
        </div>
        {this.props.stackedLayout && result}
      </div>
    );
  };
};

export default Lessons;
